module.exports = __webpack_public_path__ + "assets/img/73d44d072173e68be1c4d9e4ca8849fd.png";